<template>
	<div>
		<el-container style="position: absolute;top:55px;bottom: 0;left: 0;right: 0;">
			<el-header class="d-flex align-items-center border-bottom">
				<!-- 头部 -->
				<div class="d-flex mr-auto ">
					<el-select v-model="searchFrom.order" placeholder="請選擇图片排序方式" size="medium" class="mr-2" style="width: 150px;">
						<el-option label="降序" value="desc"></el-option>
						<el-option label="升序" value="asc"></el-option>
					</el-select>
					<el-input placeholder="輸入图片名稱" class="mr-2"
					 v-model="searchFrom.keyword" style="width: 150px;" size="medium"></el-input>
					<el-button type="success" size="medium" @click="getImageList">搜索</el-button>
				</div>
				<el-button type="warning" v-if="chooseList.length>0" size="medium" @click="unChoose">取消选中</el-button>
				<el-button type="danger" v-if="chooseList.length>0" size="medium" @click="imageDel({all:true})"  v-auth="'delImg'" >批量删除</el-button>
				<el-button type="success" size="medium" @click="OpenAlbumModel(false)" v-auth="'addImage'">創建相册</el-button>
				<el-button type="warning" size="medium" @click="uploadModel = true" v-auth="'uploadMore'">上傳图片</el-button>

			</el-header>
			<el-container>
				<el-aside class="bg-white border-right" width="200px" style="position: absolute;top:60px;bottom: 60px;left: 0;">
					<!-- 侧边 | 相册列表 -->
					<ul class="list-group list-group-flush">
						<album-item v-for="(item,index) in albums" :key="index" :item="item" :index="index" :active="albumIndex===index"
						 @change="albumChange" @edit="OpenAlbumModel" @del="albumDel"></album-item>
					</ul>
				</el-aside>
				<el-container>
					<el-main style="position: absolute;top:60px;bottom: 60px;left: 200px;right: 0;">
						<!-- 主内容 -->
						<el-row :gutter="10">
							<el-col :span="24" :lg="4" :md="6" :sm="8" v-for="(item,index) in imageList" :key="index">
								<el-card class="box-card mb-3 position-relative" shadow="hover" style="cursor: pointer;" :body-style="{'padding':'0'}">

									<div class="border" :class="{'border-danger':item.ischeck}">

										<span class="badge badge-danger" v-if="item.ischeck" style="position: absolute;right: 0;top: 0;">{{item.checkOrder}}</span>

  <el-image @click="choose(item)"
      style="width: 100%; height: 100px"
      :src="item.url"
      fit="cover"></el-image>
										<!-- <img @click="choose(item)" :src="item.url" class="w-100" style="height: 100px;" alt=""> -->
										<div class="w-100 text-white px-1" style="background-color: rgba(0,0,0,0.5);margin-top: -25px;position: absolute;">
											<span class="small">{{item.name}}</span>
										</div>

										<div class="p-2 text-center">
											<el-button-group>
												<el-button  @click="previewImage(item)" size="mini" class="p-2" icon="el-icon-view"></el-button>
												<el-button v-auth="'updateImgName'"  @click="imageEdit(item,index)" size="mini" class="p-2" icon="el-icon-edit"></el-button>
												<el-button v-auth="'delImg'"  @click="imageDel({index,item})" size="mini" class="p-2" icon="el-icon-delete"></el-button>
											</el-button-group>
										</div>
									</div>

								</el-card>
							</el-col>
						</el-row>
					</el-main>

				</el-container>
			</el-container>
			<el-footer class="d-flex border-top align-items-center px-0">
				<!-- 底部 -->
				<div style="width: 200px;flex-shrink: 0;" class="h-100 d-flex align-items-center justify-content-center border-right">
					<el-button-group>
						<el-button :disabled="albumPage===1" size="mini" icon="el-icon-arrow-left" @click="changeAlbumPage('pre')">上一页</el-button>
						<el-button size="mini"
						@click="changeAlbumPage('next')"
						:disabled="albumPage === Math.ceil(albumsTotal/10)"
						>下一页<i class="el-icon-arrow-right el-icon--right"></i></el-button>
					</el-button-group>
				</div>
				<div style="flex: 1;" class="px-2">
					<el-pagination 
					@size-change="handleSizeChange" 
					@current-change="handleCurrentChange" 
					:current-page="currentPage"
					 :page-sizes="pageSizes" 
					 :page-size="pageSize" 
					 layout="total, sizes, prev, pager, next, jumper" 
					 :total="total">
					</el-pagination>
				</div>
			</el-footer>
		</el-container>


		<!-- 修改|創建相册 -->

		<el-dialog :close-on-click-modal="false"  :title="albumModelTitle " :visible.sync="albumModel">
			<el-form ref="form" :model="albumFrom" label-width="80px">
				<el-form-item label="相册名稱">
					<el-input v-model="albumFrom.name" size="medium" placeholder="請輸入相册名稱"></el-input>
				</el-form-item>
				<el-form-item label="相册排序">
					<el-input-number size="medium" v-model="albumFrom.order" :min="0"></el-input-number>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="albumModel = false">取 消</el-button>
				<el-button type="primary" @click="confirmAlbumModel">確 定</el-button>
			</div>
		</el-dialog>


		<!-- 上傳图片 -->
		<el-dialog :close-on-click-modal="false"  title="上傳图片" :visible.sync="uploadModel" @close="__init">
			<div class="text-center">
				<el-upload class="upload-demo w-100" 
				:headers="{token:$store.state.user.token}"
				:data="{type:'admin',id:imageClassId}"
				name="imglist[]"
				:on-success="uploadSuccess"
				drag action="/admin/image/uploadMore" multiple>
					<i class="el-icon-upload"></i>
					<div class="el-upload__text">将文件拖到此处，或<em>點擊上傳</em></div>
					<div class="el-upload__tip" slot="tip">只能上傳jpg/png/gif文件，且不超過5MB</div>
				</el-upload>
			</div>

		</el-dialog>

		<!-- 预览图片 -->
		<el-dialog :close-on-click-modal="false"  :visible.sync="previewModel" width="50vw" top="5vh">
			<div style="margin: -60px -20px -30px -20px;">
				<img :src="previewUrl" class="w-100" alt="">

			</div>
		</el-dialog>
	</div>
</template>

<script>
	import albumItem from '../../components/image/album-item.vue';
	export default {
		inject:['layout'],
		components: {
			albumItem
		},
		data() {
			return {
				
				imageList: [],
				previewModel: false,
				previewUrl: "",
				uploadModel: false,
				searchFrom: {
					order: 'desc',
					keyword: ''
				},
				albumPage:1,
				albumIndex: 0,
				albumModel: false,
				albumEditIndex: -1,
				albumFrom: {
					name: '',
					order: 0
				},
				albums: [],
				// 选中數据
				chooseList: [],
				currentPage: 1,
				pageSize:10,
				pageSizes:[10,20,50,100],
				total:400,
				albumsTotal:0,
				check_list:[]
			}
		},
		computed: {
			albumModelTitle() {
				return this.albumEditIndex > -1 ? '修改相册' : '新建相册'
			},
			imageClassId(){
				let item = this.albums[this.albumIndex]
				if(item){
					return item.id
				}
				return 0
			}
		},
		created() {
			this.__init()
		},
		methods: {
			// 预览图片
			previewImage(item){
				this.previewUrl = item.url
				this.previewModel = true
			},
			uploadSuccess(response, file, fileList){
				
			},
			// 相册分页
			changeAlbumPage(type){
				if(type==='pre'){
					this.albumPage--
				}else{
					this.albumPage++
				}
				this.__init()
			},
			// 获取对应相册下的图片列表
			getImageList(){
				this.layout.loading = true;
				this.axios.post('/admin/image/imgList',{
					id:this.imageClassId,
					page:this.currentPage,
					limit:this.pageSize,
					sort:this.searchFrom.order,
					search:this.searchFrom.keyword
				},{token:true,loading:true}).then(res2=>{
					
					let list2 =  res2.data;
					if(list2.code==1){
						let data = list2.data.list
						this.imageList = data.list.map(item=>{
							return {
								id:item.id,
								name:item.name,
								url:item.url,
								ischeck:false,
								checkOrder:0
							}
						})
						
						this.check_list = data.list.map(item=>{
							return item.url
						})
						console.log(this.check_list);
						this.total = data.total
					}
					this.layout.loading = false;
				}).catch(error=>{
					this.layout.loading = false;
				})
			},
			// 初始化數据
			__init() {
				this.layout.loading = true;
				this.axios.post('/admin/image/classList',
				{
					page:this.albumPage
				},{token:true,loading:true}
				).then(res => {
					let list =  res.data;
					console.log(list)
					if(list.code==1){
						this.albums = list.data.list.list
						this.albumsTotal = list.data.list.total
						
					}
					this.getImageList()
				}).catch(err => {
					// 失敗
					console.log(err);
					this.layout.loading = false;
				})
				
			},
			handleSizeChange(val) {
				this.pageSize = val
				this.getImageList()
				//console.log(`每页 ${val} 条`);
			},
			handleCurrentChange(val) {
				this.currentPage = val
				this.getImageList()
				//console.log(`當前页: ${val}`);
			},
			//取消选中
			unChoose(){
				//找到所有选中的图片
				this.imageList.forEach(img=>{
					let i =this.chooseList.findIndex(item=>{
						return item.id === img.id
					})
					if(i> -1){
						// 取消选中样式
						img.ischeck = false
						// 排序重置
						img.checkOrder = 0
						// 从chooselist中移除
						this.chooseList.splice(i,1)
					}
				})
				
			},
			// 删除當前图片
			imageDel(obj) {
				this.$confirm(obj.all ? '是否批量删除选中的图片' : '是否删除该图片?', '提示', {
					confirmButtonText: '確定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					if (obj.all) {
						let ids = this.chooseList.map(item=>item.id)
						this.axios.post('/admin/image/delImgAll',
						{
							id:ids
						},{token:true,loading:true}
						).then(res => {
							let list =  res.data;
						
							if(list.code==1){
								this.chooseList = []
								this.getImageList()
								this.$message({
									message: '删除成功',
									type: 'success'
								});
							}
						})
						// 批量删除
						// let list = this.imageList.filter(img => {
						// 	// 对比chooselist，如果不存在则return
						// 	//return !this.chooseList.some(c=>c.id === img.id)  //簡化写法
						// 	return !this.chooseList.some(c => {
						// 		return c.id === img.id
						// 	})
						// })
						// this.imageList = list
						
					} else {
						// 單独删除
						this.axios.post('/admin/image/delImg',
						{
							id:obj.item.id,
						},{token:true,loading:true}
						).then(res => {
							let list =  res.data;
							
							if(list.code==1){
								this.$message({
									message: '删除成功',
									type: 'success'
								});
								this.getImageList()
								this.imageList.splice(obj.index, 1)
								
								
							}
						})
						
					}

					
				})

			},
			// 批量删除(无用，展示)
			imgDelAll() {
				// 遍历imagelist
				let list = this.imageList.filter(img => {
					// 对比chooselist，如果不存在则return
					//return !this.chooseList.some(c=>c.id === img.id)  //簡化写法
					return !this.chooseList.some(c => {
						return c.id === img.id
					})
				})
				this.imageList = list
				this.chooseList = []
			},
			// 选中图片
			choose(item) {
				if (!item.ischeck) {
					// 加入选中
					this.chooseList.push({
						id: item.id,
						url: item.url
					})
					//item.ischeck = !item.ischeck
					//计算序號 
					item.checkOrder = this.chooseList.length
					// 修改狀態
					item.ischeck = true
					return;
				}
				// 取消选中
				// 找到在chooseList中的索引
				let i = this.chooseList.findIndex(v => v.id === item.id)
				console.log(i);
				if (i === -1) return;
				// 重新计算序號
				let length = this.chooseList.length
				// 取消选中中間部分
				if (i + 1 < length) {
					// 重新计算imagelist中的序號
					for (let j = i; j < length; j++) {
						let no = this.imageList.findIndex(v => v.id === this.chooseList[j].id)
						if (no > -1) {
							this.imageList[no].checkOrder--
						}
					}
				}
				// 删除
				this.chooseList.splice(i, 1)
				// 修改狀態
				item.ischeck = false
				// 重置序號
				item.checkOrder = 0
			},
			

			// 修改图片
			imageEdit(item, index) {
				this.$prompt('請輸入新名稱', '提示', {
					confirmButtonText: '確定',
					cancelButtonText: '取消',
					inputValue: item.name,
					inputValidator(val) {
						if (val === '') {
							return '图片名稱不能为空'
						}
					}
				}).then(({
					value
				}) => {
					this.axios.post('/admin/image/updateImgName',
					{
						name:value,
						id:item.id,
					},{token:true,loading:true}
					).then(res => {
						let list =  res.data;
						if(list.code==1){
							this.$message({
								message: '修改成功',
								type: 'success'
							});
							item.name = value
							
						}
					})
					
					
				})
			},
			
			// 切换相册
			albumChange(index) {
				this.albumIndex = index;
				this.getImageList()
			},
			// 打开相册修改|創建框
			OpenAlbumModel(obj) {
				if (obj) {
					// 修改
					let {
						item,
						index
					} = obj
					//初始化表單
					this.albumFrom.name = item.name
					this.albumFrom.order = item.order
					this.albumEditIndex = index
					// 打开模态框
					return this.albumModel = true

				} else {
					// 創建
					
					this.albumFrom = {
						name: '',
						order: 0
					}
					this.albumEditIndex = -1
					return this.albumModel = true
				}
			},
			// 修改或創建相册
			confirmAlbumModel() {
				// 判断是否为修改
				if (this.albumEditIndex > -1) {
					
					// 修改
					
					
					this.albumEdit()
					return this.albumModel = false;
				}
				
				
				this.axios.post('/admin/image/addImage',
				{
					name:this.albumFrom.name,
					sort:this.albumFrom.order,
				},{token:true,loading:true}
				).then(res => {
					let list =  res.data;
					if(list.code==1){
						this.$message.success(list.msg);
						//追加相册 新建相册
						this.albums.unshift({
							name: this.albumFrom.name,
							order: this.albumFrom.order,
							num: 0
						})
						this.__init()
						return this.albumModel = false;
					}
					
				}).catch(err => {
					// 失敗
					console.log(err);
				})
				
				
			},
			//修改相册
			albumEdit() {
				this.axios.post('/admin/image/updateClassName',
				{
					name:this.albumFrom.name,
					order:this.albumFrom.order,
					id:this.albums[this.albumEditIndex].id,
				},{token:true,loading:true}
				).then(res => {
					let list =  res.data;
					if(list.code==1){
						this.$message({
							message: '修改成功',
							type: 'success'
						});
						this.albums[this.albumEditIndex].name = this.albumFrom.name
						this.albums[this.albumEditIndex].order = this.albumFrom.order
						this.__init()
						
					}
				})
				
				
			},
			// 删除相册
			albumDel(index) {
				this.$confirm('此操作将永久删除该相册, 是否继续?', '提示', {
					confirmButtonText: '確定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.axios.post('/admin/image/delClass',
					{
						id:this.albums[index].id,
					},{token:true,loading:true}
					).then(res => {
						let list =  res.data;
						
						if(list.code==1){
							this.$message({
								message: '删除成功',
								type: 'success'
							});
							this.__init()()
							this.albums.splice(index, 1);
							
							
						}
					})
					
				})

			}

		}
	}
</script>

<style>
	.sum-active {
		color: #67c23a !important;
		background-color: #f0f9eb !important;
		border-color: #c2e7b0 !important;
	}
</style>
